const PaymentOptions = {
  ON_DELIVERY: 'cache_on_delivery',
  ONLINE: 'online',
  OVER_FIRST_BILL: 'over_first_bill',
  INSTALLMENTS: 'installments',
} as const;

type PaymentOptionsKeys = keyof typeof PaymentOptions;
export type PaymentOptionsType = typeof PaymentOptions[PaymentOptionsKeys];

export default PaymentOptions;
